
import { UseFormReturn } from "react-hook-form";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { ProcurementFormValues } from "../schema";

interface PaymentTypeFieldProps {
  form: UseFormReturn<ProcurementFormValues>;
}

export const PaymentTypeField = ({ form }: PaymentTypeFieldProps) => {
  return (
    <FormField
      control={form.control}
      name="payment_term_type"
      render={({ field }) => (
        <FormItem className="space-y-3">
          <FormLabel>Payment Type</FormLabel>
          <FormControl>
            <RadioGroup
              onValueChange={field.onChange}
              defaultValue={field.value}
              className="flex flex-col space-y-1"
            >
              <div className="flex items-center space-x-2">
                <RadioGroupItem value="upfront" id="upfront" />
                <label htmlFor="upfront" className="cursor-pointer">Upfront Payment</label>
              </div>
              <div className="flex items-center space-x-2">
                <RadioGroupItem value="term" id="term" />
                <label htmlFor="term" className="cursor-pointer">Term Payment</label>
              </div>
            </RadioGroup>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
